import React from "react";
import { FaArrowLeftLong, FaArrowRightLong } from "react-icons/fa6";
import styles from "./arrow-button.module.scss";

type Props = {
  onClick: () => any;
};

const ArrowButtonLeft = ({ onClick }: Props) => {
  return (
    <button onClick={onClick} className={styles.button}>
      <FaArrowLeftLong />
    </button>
  );
};

export default ArrowButtonLeft;
